module.exports = __webpack_public_path__ + "static/img/vocation.051df40.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/vocation.png
// module id = y0Rw
// module chunks = 1